<template>
  <SOSlotModal
      modal-title="Menyalakan Mesin"
      :modal-id="id"
      @close="close"
  >
    <template v-slot:modal-body>
      <div class="f-c-black f-regular f-16">Ingin dinyalakan seberapa lama?</div>
      <div class="f-c-midgrey f-regular f-14">Isi 0 untuk menyalakan tanpa batas waktu</div>
      <SOInputNumeric
          placeholder="0"
          :prefix-right="true"
          prefix="Menit"
          :max-length="2"

          @input="(val) => { input.timer = val }"
      />
    </template>
    <template v-slot:modal-footer>
      <SOButton
          text="Nyalakan Sekarang"
          :primary="true"
          :full="true"
          :loading="loading"
          @action="turnOnMesin"
      />
    </template>
  </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOInputNumeric from "@/so-components/global/input/SOInputNumeric";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
  name: "SnapMesinModalTurnOn",
  components: {SOButton, SOInputNumeric, SOInputNominal, SOSlotModal},
  props: {
    idMesin: String
  },
  data() {
    return {
      id: "modal-turnon",
      loading: false,
      input: {
        timer: 0
      }
    }
  },
  methods: {
    close() {
      $("#" + this.id).modal("hide");
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
    async turnOnMesin(){
      let payload = {
        menit: this.input.timer,
        idsnap_mesin: this.idMesin
      }

      this.loading = true
      await this.$store.dispatch("snapMesinModule/turnOnMesin", payload)
      this.loading = false
      await this.close()
    }
  },
  mounted() {
    $("#" + this.id).modal("show");
  }
}
</script>

<style scoped>

</style>